var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-form',{ref:"formRef",attrs:{"label-width":"180px","label-position":"left","model":_vm.formData,"validate-on-rule-change":false}},[_c('FormItemComp',{ref:"FormItemComp",attrs:{"config":_vm.config,"form-state":_vm.root,"rootFormData":_vm.formData,"rootFormDataOptions":_vm.formDataOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }